export const fr = {
  appName: `Épitrousse`,
  kit: `Trousse`,
  about: `À propos`,
  resources: `Références`,
  home: `Accueil`,
  impacts: `Impacts`,
  adult: `Adulte`,
  children: `Enfant`,
  treatments: `Traitements`
};
